<section class="container gallery-section">
  <h3>
    Birou Vânzări Dream Residence
  </h3>
  <div class="gallery-wrapper">
    <div
      *ngFor="let img of officeImages; let i = index; trackBy: listTrackingService.disableUpdate"
      class="gallery-item"
      (click)="open(officeImages, i, $event)"
    >
      <img
        [src]="img.url"
        class="image"
        loading="lazy"
      >
    </div>
  </div>
</section>

<section class="container gallery-section">
  <h3>
    Randări exterior
  </h3>
  <div class="gallery-wrapper">
    <div
      *ngFor="let img of exteriorImages; let i = index; trackBy: listTrackingService.disableUpdate"
      class="gallery-item"
      (click)="open(exteriorImages, i, $event)"
    >
      <img
        [src]="img.url"
        class="image"
        loading="lazy"
      >
    </div>
  </div>
</section>

<section class="container gallery-section">
  <h3>
    Interioare mobilate blocuri anterioare
  </h3>
  <div class="gallery-wrapper">
    <div
      *ngFor="let img of furnishedImages; let i = index; trackBy: listTrackingService.disableUpdate"
      class="gallery-item"
      (click)="open(furnishedImages, i, $event)"
    >
      <img
        [src]="img.url"
        class="image"
        loading="lazy"
      >
    </div>
  </div>
</section>

<section class="container gallery-section">
  <h3>
    Interioare blocuri anterioare
  </h3>
  <div class="gallery-wrapper">
    <div
      *ngFor="let img of interiorImages; let i = index; trackBy: listTrackingService.disableUpdate"
      class="gallery-item"
      (click)="open(interiorImages, i, $event)"
    >
      <img
        [src]="img.url"
        class="image"
        loading="lazy"
      >
    </div>
  </div>
</section>

<section
  class="container gallery-section"
>
  <h3>
    Tur virtual
  </h3>
  <div class="virtual-tour">
    <div class="virtual-tour-item">
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQs5?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
    <div class="virtual-tour-item">
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQjS?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
    <div class="virtual-tour-item">
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQjH?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>

    <div
      *ngIf="!isMobileSafari()"
      class="virtual-tour-item"
    >
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQjk?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
    <div
      *ngIf="!isMobileSafari()"
      class="virtual-tour-item"
    >
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQVD?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
    <div
      *ngIf="!isMobileSafari()"
      class="virtual-tour-item"
    >
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQVP?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
    <div
      *ngIf="!isMobileSafari()"
      class="virtual-tour-item"
    >
      <iframe
        loading="lazy"
        src="https://kuula.co/share/collection/7kQVp?logo=-1&card=1&info=1&fs=1&vr=1&zoom=1&sd=1&gyro=0&autorotate=0.55&autop=60&autopalt=1&thumbs=3&inst=0"
        frameborder="0"
        allowfullscreen
        allow="xr-spatial-tracking"
      ></iframe>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/gallery-page/gallery-page.component.html